import React, { useState } from 'react';
import Layout from './theme/Layout'
import Hero from './theme/hero';
import CategoryCarousel from './theme/category-carousel';
import EventsGrid from './theme/events-grid';
import { useSelector } from 'react-redux';

const Home = () => {
  const { events, banners, categories } = useSelector(state => state.session);
  console.log(events, banners, categories);
  const [selectedType, setSelectedType] = useState(null);

  const handleTypeFilter = (typeId) => {
    setSelectedType(typeId);
  };

  return (
    <Layout title="Inicio">
      {/* Banner remains independent */}
      <Hero featuredEvents={banners} />
      <CategoryCarousel />
      {/* Events grid updates with category filters */}
      <EventsGrid
        events={events}
        onTypeFilter={handleTypeFilter}
        selectedType={selectedType}
      />
    </Layout>
  );
};

export default Home;
